import { Children } from 'react';
import { Collapse, Tabs } from 'antd';
import usePageState from '../helpers/usePageState';

export function PersistedTabs({ name, defaultActiveKey, children, ...tabsProps }) {
  const tabKeys = [];
  Children.forEach(children, (child) => {
    if (child?.key != null) tabKeys.push(String(child.key));
  });

  const fallbackKey = defaultActiveKey ?? tabKeys[0];
  const [savedKey, setSavedKey] = usePageState(name, fallbackKey);

  return (
    <Tabs
      {...tabsProps}
      activeKey={tabKeys.includes(savedKey) ? savedKey : fallbackKey}
      onChange={setSavedKey}>
      {children}
    </Tabs>
  );
}

export function PersistedCollapse({ name, defaultActiveKey = [], children, ...collapseProps }) {
  const [activeKeys, setActiveKeys] = usePageState(name, defaultActiveKey);

  return (
    <Collapse
      {...collapseProps}
      activeKey={[].concat(activeKeys).map(String)}
      onChange={setActiveKeys}>
      {children}
    </Collapse>
  );
}
